import { render } from "./Thanks.vue?vue&type=template&id=106940bb"
import script from "./Thanks.vue?vue&type=script&lang=js"
export * from "./Thanks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__